const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:4000";

const getWords = async (lang) => {
  const response = await fetch(`/${lang}_words.json`);
  const words = await response.json();
  return words;
};

const sendResults = async (result) => {
  var formdata = new FormData();

  formdata.append("firstPhase", JSON.stringify(result.firstPhaseTextResult));
  formdata.append("lastPhase", JSON.stringify(result.lastPhaseTextResult));
  formdata.append("email", result.email);
  formdata.append("name", result.name);

  var requestOptions = {
    method: "POST",
    body: formdata,
    redirect: "follow",
  };

  await fetch(`${BACKEND_URL}/results`, requestOptions);
};

const apiService = { getWords, sendResults };

export default apiService;
